
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PermissionItemProps } from ".";
import { AppMessage } from "components";
import { apiAuthPermission } from "apis/auth/auth-permission";
import { authUpdatePermission } from "store/auth";

interface ApiPermissionUserIndexInputProps {
    id: number;
}

type ApiPermissionUserIndexOutputProps = OutputBaseProps<PermissionItemProps[], ApiPermissionUserIndexInputProps>;

export const apiPermissionUserIndex = async (data: ApiPermissionUserIndexInputProps) => {
    const res = (await axios.get<ApiPermissionUserIndexOutputProps>(`/api/permission/find/user/${data.id}`))
        .data;
    return res;
};


interface ApiPermissionUserUpdateInputProps {
    id: number;
    permissionIds: number[]
}
export const apiPermissionUseUpdate = async (data: ApiPermissionUserUpdateInputProps) => {
    // store.dispatch(loading());
    const res = (await axios.put<ApiPermissionUserIndexOutputProps>(`/api/permission/update/user`, {
        userId: data.id,
        permissionIds: data.permissionIds
    }))
        .data;
    if (res.code === 0 && res.data) {
        const userId = store.getState().auth.user?.id;
        if (userId === data.id) {
            const resP = await apiAuthPermission();
            store.dispatch(authUpdatePermission({ permissions: resP.data }))
        }
        AppMessage.success({
            title: "Thông báo",
            message: "Cập nhật thành công"
        })
    }
    return res;
};